/* eslint-disable max-len */
export const verifactuMarkDownText = `
**DECLARACIÓN RESPONSABLE DEL SISTEMA INFORMÁTICO DE FACTURACIÓN**

VAT Compliance España, S.L., operando como eezi – Powered by VAT IT

30 de julio de 2025

**1.a) Nombre del sistema informático a que se refiere esta declaración responsable:**

eezi – Powered by VAT IT

**1.b) Código identificador del sistema informático a que se refiere el apartado a) de esta declaración responsable:**

eezi.1.0

**1.c) Identificador completo de la versión concreta del sistema informático a que se refiere esta declaración responsable:**

1.0

**1.d) Componentes, hardware y software, de que consta el sistema informático a que se refiere esta declaración responsable, junto con una breve descripción de lo que hace dicho sistema informático y de sus principales funcionalidades:**

eezi se trata de un software en la nube (software como servicio -SaaS-) que permite facturar y gestionar la facturación realizada, accesible desde cualquier dispositivo con conexión a internet, sin necesidad de instalación en equipos físicos del usuario.

Este producto está pensado para ser utilizado directamente desde el navegador, en cualquier entorno de trabajo. El acceso es multiusuario, gestionado a través de credenciales y roles.

La infraestructura y almacenamiento están alojados en servidores seguros, con respaldo automático y actualizaciones continuas del sistema.

Este software cuenta con las funcionalidades habituales en este tipo de aplicaciones: capturar información de facturación, expedir facturas, consultar facturas, estadísticas de facturación y exportación de datos. Además, permite generar los elementos obligatorios establecidos por la normativa Verifactu, como el código QR y el texto conforme, encadenar los registros de facturas garantizando su inalterabilidad, y conservar los datos de forma íntegra, accesible y trazable.

Este software permite gestionar de forma independiente varias facturaciones dentro de él, cumpliendo separadamente con la normativa mencionada en el apartado 1.k) de esta declaración responsable para cada una de ellas, como si, en la práctica, se tratara de sistemas informáticos de facturación distintos.

**1.e) Indicación de si el sistema informático a que se refiere esta declaración responsable se ha producido de tal manera que, a los efectos de cumplir con el Reglamento, solo pueda funcionar exclusivamente como «VERI\*FACTU»:**

Sí, el sistema informático eezi ha sido diseñado y desarrollado exclusivamente para operar bajo la modalidad “VERI\*FACTU”, cumpliendo con los requisitos de generación y envío en tiempo real de los registros de facturación.

**1.f) Indicación de si el sistema informático a que se refiere la declaración responsable permite ser usado por varios obligados tributarios o por un mismo usuario para dar soporte a la facturación de varios obligados tributarios:**

El sistema informático eezi puede ser utilizado por varios contribuyentes.

**1.g) Tipos de firma utilizados para firmar los registros de facturación y de evento en el caso de que el sistema informático a que se refiere esta declaración responsable no sea utilizado como «VERI\*FACTU».**

Al tratarse de un producto de facturación exclusivamente utilizable en la modalidad «VERI\*FACTU», no se realiza firma electrónica expresa sobre los registros de facturación generados.

**1.h) Razón social de la entidad productora del sistema informático a que se refiere esta declaración responsable:**

VAT Compliance España, S.L., operando como eezi – Powered by VAT IT

**1.i) Número de identificación fiscal (NIF) español de la entidad productora del sistema informático a que se refiere esta declaración responsable:**

B19759679

**1.j) Dirección postal completa de contacto de la entidad productora del sistema informático a que se refiere esta declaración responsable:**

CALLE ARIBAU, 191 - P. 5 PTA

8021 - Barcelona (Barcelona)

España

**1.k) La entidad productora del sistema informático a que se refiere esta declaración responsable hace constar que dicho sistema informático, en la versión indicada en ella, cumple con lo dispuesto en el artículo 29.2.j) de la Ley 58/2003, de 17 de diciembre, General Tributaria, en el Reglamento que establece los requisitos que deben adoptar los sistemas y programas informáticos o electrónicos que soporten los procesos de facturación de empresarios y profesionales, y la estandarización de formatos de los registros de facturación, aprobado por el Real Decreto 1007/2023, de 5 de diciembre, en la Orden HAC/1177/2024, de 17 de octubre, y en la sede electrónica de la Agencia Estatal de Administración Tributaria para todo aquello que complete las especificaciones de dicha orden.**

**1.l)**

**\- Fecha en que la entidad productora de este sistema informático suscribe esta declaración responsable del mismo:**

30 de julio de 2025

**\- Lugar en que la entidad productora de este sistema informático suscribe esta declaración responsable del mismo:**

Barcelona (Barcelona)

**ANEXO**

**2.a) Otras formas de contacto con la entidad productora del sistema informático a que se refiere esta declaración responsable:**

– Teléfono: +27 11 555 8555

– Correo electrónico: [info@eezi.io](mailto:info@eezi.io)

**2.b) Direcciones de internet de la entidad productora del sistema informático a que se refiere esta declaración responsable:**

Sitio web de la empresa:

[eezi.io](https://www.eezi.io)

Información sobre este producto en el sitio web de la empresa:

[eezi.io](https://www.eezi.io)

Acceso web a la declaración responsable:

<https://eezi.io/legal/verifactu/>

Acceso al histórico de declaraciones responsables de las versiones de este producto: <https://eezi.io/legal/verifactu/>

**2.c) El sistema informático a que se refiere esta declaración responsable cumple las diferentes especificaciones técnicas y funcionales contenidas en la Orden HAC/1177/2024, de 17 de octubre, y en la sede electrónica de la Agencia Estatal de Administración Tributaria para todo aquello que complete las especificaciones de dicha orden, de la siguiente manera:**

Además del modo que es de obligado cumplimiento en ciertos casos (como el algoritmo de huella a emplear), otras implementaciones utilizadas son:

– El sistema objeto de esta declaración cumple íntegramente con las especificaciones técnicas y funcionales exigidas por el Reglamento regulador del sistema de emisión de facturas verificables, incluyendo tanto los elementos de obligado cumplimiento como otras implementaciones complementarias que refuerzan su fiabilidad, seguridad e interoperabilidad:

– Empleo de la tecnología transaccional del sistema gestor de base de datos utilizado para lograr la consolidación, en una sola unidad transaccional, de la expedición de la factura y la generación del registro de facturación correspondiente a la factura.`;
